import { DragDropModule } from '@angular/cdk/drag-drop';
import { HTTP_INTERCEPTORS, HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { NgModule, LOCALE_ID, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule, ToastrService } from 'ngx-toastr';

import { Utils } from './_helpers/utilities';
import { DebounceModule } from './_shared/directives/debounce/debounce.module';
import { AutoCompletTabModule } from './_shared/directives/tab-directive/autocomplete-tab.module';
import { AuthGuard, DashboardGuard } from './_shared/gaurds';
import { LoaderModule } from './_shared/modules/loader/loader.module';
import { EsmnseToEsmModule, NullCheckModule } from './_shared/pipes';
import { EventsService, HttpInterceptorService } from './_shared/providers';
import { GenericRequestsService } from './_shared/providers/generic-requests/generic-requests.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { registerLocaleData } from '@angular/common';
import localeIn from '@angular/common/locales/en-IN';
import { DEFAULT_LOCALE } from './_helpers';
import { ConfigurationService } from './_shared/providers/configuration/configuration.service';
import { HeaderNudgeModule } from './_shared/components/header-nudge/header-nudge.module';
import { ConnectivityService } from './_shared/providers/connectivity/connectivity-service.service';
import { NudgeService } from './_shared/providers/nudges/nudge.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { InternetConnectivityService } from './_shared/providers/internet-connectivity/internet-connectivity.service';
import { register } from 'swiper/element/bundle';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts';
import { CustomCardComponent } from './_shared/components/custom-card/custom-card.component';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import {LottieModule} from 'ngx-lottie'
import player from 'lottie-web';
import { OrderNotificationService } from './_shared/providers/order-notification/order-notification.service';
import { OauthLoadingModule } from './_shared/lottie/oauth-loading/oauth-loading.module';
import { NominationPopupComponent } from './_shared/components/nomination-popup/nomination-popup.component';
import { NomineeOptOutPopupComponent } from './_shared/components/nominee-opt-out-popup/nominee-opt-out-popup.component';
import { MatIconModule } from '@angular/material/icon';

registerLocaleData(localeIn, DEFAULT_LOCALE);

register();

// Note we need a seperate function as it's required
// by the AOT compiler.
export function playerFactory(){
    return player
  }


@NgModule({
    declarations: [
        AppComponent,
        NominationPopupComponent,
        NomineeOptOutPopupComponent,
        // RightMenlickDirective
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        HttpClientJsonpModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot(Utils.toastrConfig),
        LoaderModule,
        DebounceModule,
        AutoCompletTabModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        FormsModule,
        BrowserModule,
        MatFormFieldModule,
        MatOptionModule,
        MatInputModule,
        DragDropModule,
        MatTabsModule,
        NullCheckModule,
        EsmnseToEsmModule,
        MatSelectModule,
        MatButtonModule,
        MatDialogModule,
        HeaderNudgeModule,
        MatIconModule,
        MatSnackBarModule,
        CustomCardComponent,
        NgxEchartsModule.forRoot({
            echarts
        }),
        LottieModule.forRoot({player: playerFactory}),
        OauthLoadingModule
    ],
    providers: [
        ToastrService,
        GenericRequestsService,
        ConnectivityService,
        NudgeService,
        EventsService,
        InternetConnectivityService,
        OrderNotificationService,
        // Http Interceptor
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptorService,
            multi: true
        },
        { provide: LOCALE_ID, useValue: DEFAULT_LOCALE },
        {
            provide: APP_INITIALIZER,
            useFactory: (configService: ConfigurationService) => () => configService.initFirebaseConfig(),
            deps: [ConfigurationService],
            multi: true
        },
        {
            provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
            useValue: {
                position: 'above'
            }
        },
        // Gaurds
        DashboardGuard,
        AuthGuard
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
    constructor() {
    }
}
